import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PasswordInput from '../password/password-input';
import NewPasswordInput from '../new-password-input/new-password-input';
import Loading from '../loading/loading';

const NewPassword = () => {
  const location = useLocation();
  const session = location.state?.session; // Retrieve the session token

  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      const response = await fetch(
        process.env.REACT_APP_FACES_API_BASE + '/drm-auth',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            username: email,
            password: password,
            new_password: newPassword,
            session: session, // Use the session token here
          }),
        }
      );
      const data = await response.json();
      if (data.access_token) {
        window.alert(
          'Password changed successfully. Please log in with your new password.'
        );
        navigate('/login');
      } else {
        window.alert(
          'Password reset failed. Please check your credentials and try again.'
        );
      }
    } catch (error) {
      window.alert('Password reset error. Please try again.');
      console.error('Password reset error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return <Loading />;

  return (
    <form onSubmit={handleSubmit} id="main-form" autoComplete="off">
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        autoComplete="username"
      />
      <PasswordInput
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        placeholder="Password"
        inputId="password-input"
        autoComplete="current-password"
      />
      <NewPasswordInput
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        showPassword={showNewPassword}
        setShowPassword={setShowNewPassword}
      />
    </form>
  );
};

export default NewPassword;
